const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-store-contact'] = {
        c: () => require('partner/modules/hei-store-contact/hei-store-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-store-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-store-contact'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-store-contact|hei-store-contact'] = {
                c: () => require('partner/modules/hei-store-contact/hei-store-contact.view.tsx'),
                cn: '__local__-__local__-hei-store-contact'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };